
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#faa61a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","data-name":"vuesax/twotone/danger"}},[_c('path',{attrs:{"d":"M20 15v8.333","opacity":".34"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20 35.683H9.9c-5.783 0-8.2-4.133-5.4-9.183l5.2-9.367 4.9-8.8c2.967-5.35 7.833-5.35 10.8 0l4.9 8.817 5.2 9.367c2.8 5.05.367 9.183-5.4 9.183H20z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.991 28.333h.015","opacity":".34"}})])])
          )
        }
      }
    